// extracted by mini-css-extract-plugin
module.exports = {"profile":"MyProfile_profile__3EciL","main":"MyProfile_main__3Z8gk","heading":"MyProfile_heading__2YZ5M","body":"MyProfile_body__1F2_D","ibutton":"MyProfile_ibutton__3NBcm"};